module.exports = __webpack_public_path__ + "img/chat1-1.14e958ae.png";